import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Icon from 'widgets/Icon/Icon';
import { brightness } from '../../utils/colors';
import Tooltip from 'widgets/Tooltip/Tooltip';

const isDarkColor = (hex) =>
  brightness(hex) < 128;

const tickColorClass = (hex) =>
  (isDarkColor(hex) ? 'bop-colorBox__lightTick' : 'bop-colorBox__darkTick');

export default function ColorBox({ colourCode, colourName }) {
  const [showTooltip, setTooltipName] = useState(false);
  return (
    <div
      className={`bop-colorBox ${tickColorClass(colourCode)}`}
      style={{ backgroundColor: colourCode }}
      onMouseEnter={() => { setTooltipName(true); }}
      onMouseLeave={() => { setTooltipName(false); }}
    >
      <Icon name="checked" />
      {showTooltip && colourName && (
      <Tooltip
        defaultPositions={['below', 'center']}
        className="bop-colorBoxTooltip"
        autoHide
        forceShow
      >{colourName}
      </Tooltip>
      )}
    </div>
  );
}

ColorBox.propTypes = {
  colourCode: PropTypes.string.isRequired,
  colourName: PropTypes.string,
};
